import { render, staticRenderFns } from "./ModernizationWave.vue?vue&type=template&id=5da03b38"
import script from "./ModernizationWave.vue?vue&type=script&lang=js"
export * from "./ModernizationWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports